<template>
  <div class="about">
    <Header />
    <h1>Under construction 🚧</h1>
    <Footer />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default defineComponent({
  components: {
    Header,
    Footer,
  },
});
</script>
